// create a react compoment
import { ReactElement } from 'react'

import { Navigate } from 'react-router-dom'

import { useUserContext } from 'context/UserContext'
import { getPath } from 'routing/pagePaths'

function MfaCheck(): ReactElement | null {
    const userContext = useUserContext()

    const needsToSetUpMfa = userContext.userMfaSettings?.needsToSetUpMfa

    const setupPath = getPath('authSignUpMfaSetupPage')

    if (needsToSetUpMfa) {
        return <Navigate to={setupPath} />
    }

    return null
}

export default MfaCheck
